/**
 * Audit Log Page
 *
 * Filter panel UI, user search clear, datepicker bridging, rows-per-page.
 * Filtering/pagination is handled declaratively by HTMX.
 */

/**
 * Initialize the audit log page
 */
export function initAuditLog(options = {}) {
  const { hasActiveFilters = false } = options;
  initFilterPanelUI(hasActiveFilters);
  initDatepickerBridge();
  setupRowsPerPage();
  bindAfterSettleOnce();
}

function initFilterPanelUI(hasActiveFilters) {
  var panel = document.getElementById('filter-panel');
  var chevron = document.getElementById('filter-chevron');
  var toggleBtn = document.getElementById('toggle-filters-btn');
  var resetBtn = document.getElementById('reset-filters-btn');
  var clearUserBtn = document.getElementById('clear-user-btn');
  var form = document.getElementById('filterForm');
  var userInput = document.getElementById('user-input');

  if (panel && hasActiveFilters) {
    panel.classList.remove('hidden');
    if (chevron) chevron.classList.add('rotate-180');
  }

  // Per-node idempotency flag via plain property — does not serialize
  // into HTMX hx-boost history snapshots.
  if (toggleBtn && panel && !toggleBtn._alFilterBound) {
    toggleBtn._alFilterBound = true;
    toggleBtn.addEventListener('click', function () {
      panel.classList.toggle('hidden');
      if (chevron) chevron.classList.toggle('rotate-180');
    });
  }

  if (resetBtn && form && !resetBtn._alResetBound) {
    resetBtn._alResetBound = true;
    resetBtn.addEventListener('click', function () {
      form.querySelectorAll('select[name="action"], select[name="entity_type"]').forEach(function (sel) {
        sel.value = '';
        var wrapper = sel.closest('.custom-select-wrapper');
        if (wrapper) {
          var textEl = wrapper.querySelector('.custom-select-text');
          if (textEl && sel.options[0]) {
            textEl.textContent = sel.options[0].text;
          }
        }
      });

      if (userInput) userInput.value = '';
      if (clearUserBtn) clearUserBtn.classList.add('hidden');

      form.querySelectorAll('input[name="date_from"], input[name="date_to"]').forEach(function (input) {
        input.value = '';
      });

      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  if (clearUserBtn && userInput && form && !clearUserBtn._alClearBound) {
    clearUserBtn._alClearBound = true;
    clearUserBtn.addEventListener('click', function () {
      userInput.value = '';
      clearUserBtn.classList.add('hidden');
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  if (userInput && clearUserBtn && !userInput._alInputBound) {
    userInput._alInputBound = true;
    userInput.addEventListener('input', function () {
      clearUserBtn.classList.toggle('hidden', !userInput.value.trim());
    });
  }
}

/**
 * Bridge Flowbite datepicker's changeDate event to a native change event
 * so HTMX's hx-trigger can pick it up.
 */
function initDatepickerBridge() {
  var form = document.getElementById('filterForm');
  if (!form) return;

  form.querySelectorAll('input[datepicker]').forEach(function (input) {
    if (input._alDpBound) return;
    input._alDpBound = true;
    input.addEventListener('changeDate', function () {
      this.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
}

/**
 * Rows-per-page selector syncs with the hidden input in the form
 * and triggers a form submit so HTMX handles it.
 */
function setupRowsPerPage() {
  var rppSelect = document.getElementById('rows-per-page');
  var hiddenPerPage = document.getElementById('hidden-per-page');
  var form = document.getElementById('filterForm');

  if (rppSelect && hiddenPerPage && form && !rppSelect._alRppBound) {
    rppSelect._alRppBound = true;
    rppSelect.addEventListener('change', function () {
      hiddenPerPage.value = this.value;
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }
}

let afterSettleBound = false;

function bindAfterSettleOnce() {
  if (afterSettleBound) return;
  afterSettleBound = true;
  document.addEventListener('htmx:afterSettle', function (e) {
    var target = e.detail && e.detail.target;
    if (!target || target.id !== 'list-results') return;
    if (typeof window.reinitFlowbiteWidgets === 'function') {
      window.reinitFlowbiteWidgets(target);
    }
  });
}

/**
 * Auto-init entry point (wired via ``data-auto-init="auditLog"``).
 */
export function autoInitAuditLog() {
  const root = document.querySelector('[data-auto-init="auditLog"]');
  if (!root) return;
  initAuditLog({
    hasActiveFilters: root.dataset.hasActiveFilters === '1',
  });
}

window.initAuditLog = initAuditLog;
